import Component from '@glimmer/component';

export default class Typography extends Component {
  typographyClasses = [
    { name: 'H0-Black', tooltip: '84px / 900 / 135%' },
    { name: 'H0-Bold', tooltip: '84px / 700 / 135%' },
    { name: 'H0-Medium', tooltip: '84px / 500 / 135%' },
    { name: 'H0-Regular', tooltip: '84px / 400 / 135%' },
    { name: 'H0-Light', tooltip: '84px / 300 / 135%' },
    { name: 'H0-Italic', tooltip: '84px / 275 / 135%' },
    { name: 'H1-Black', tooltip: '48px / 900 / 135%' },
    { name: 'H1-Bold', tooltip: '48px / 700 / 135%' },
    { name: 'H1-Medium', tooltip: '48px / 500 / 135%' },
    { name: 'H1-Regular', tooltip: '48px / 400 / 135%' },
    { name: 'H1-Italic', tooltip: '48px / 275 / 135%' },
    { name: 'H2-Black', tooltip: '36px / 900 / 135%' },
    { name: 'H2-Bold', tooltip: '36px / 700 / 135%' },
    { name: 'H2-Medium', tooltip: '36px / 500 / 135%' },
    { name: 'H2-Regular', tooltip: '36px / 400 / 135%' },
    { name: 'H2-Italic', tooltip: '36px / 300 / 135%' },
    { name: 'H3-Black', tooltip: '28px / 900 / 135%' },
    { name: 'H3-Bold', tooltip: '28px / 700 / 135%' },
    { name: 'H3-Medium', tooltip: '28px / 500 / 135%' },
    { name: 'H3-Regular', tooltip: '28px / 400 / 135%' },
    { name: 'H3-Italic', tooltip: '28px / 300 / 135%' },
    { name: 'H4-Black', tooltip: '24px / 900 / 135%' },
    { name: 'H4-Bold', tooltip: '24px / 700 / 135%' },
    { name: 'H4-Medium', tooltip: '24px / 400 / 135%' },
    { name: 'H4-Regular', tooltip: '24px / 400 / 135%' },
    { name: 'H4-Italic', tooltip: '24px / 300 / 135%' },
    { name: 'H5-Black', tooltip: '20px / 900 / 135%' },
    { name: 'H5-Bold', tooltip: '20px / 700 / 135%' },
    { name: 'H5-Medium', tooltip: '20px / 500 / 135%' },
    { name: 'H5-Regular', tooltip: '20px / 400 / 135%' },
    { name: 'H5-Italic', tooltip: '20px / 300 / 135%' },
    { name: 'BodyL-Black', tooltip: '18px / 900 / 135%' },
    { name: 'BodyL-Bold', tooltip: '18px / 700 / 135%' },
    { name: 'BodyL-Medium', tooltip: '18px / 500 / 135%' },
    { name: 'BodyL-Regular', tooltip: '18px / 400 / 135%' },
    { name: 'BodyL-Italic', tooltip: '18px / 300 / 135%' },
    { name: 'BodyM-Black', tooltip: '16px / 900 / 135%' },
    { name: 'BodyM-Bold', tooltip: '16px / 700 / 135%' },
    { name: 'BodyM-Medium', tooltip: '16px / 500 / 135%' },
    { name: 'BodyM-Regular', tooltip: '16px / 400 / 135%' },
    { name: 'BodyM-Italic', tooltip: '16px / 300 / 135%' },
    { name: 'BodyS-Black', tooltip: '14px / 900 / 135%' },
    { name: 'BodyS-Bold', tooltip: '14px / 700 / 135%' },
    { name: 'BodyS-Medium', tooltip: '14px / 500 / 135%' },
    { name: 'BodyS-Regular', tooltip: '14px / 400 / 135%' },
    { name: 'BodyS-Italic', tooltip: '14px / 300 / 135%' },
    { name: 'TinyM-Black', tooltip: '12px / 900 / 135%' },
    { name: 'TinyM-Bold', tooltip: '12px / 700 / 135%' },
    { name: 'TinyM-Medium', tooltip: '12px / 500 / 135%' },
    { name: 'TinyM-Regular', tooltip: '12px / 400 / 135%' },
    { name: 'TinyM-Italic', tooltip: '12px / 300 / 135%' },
    { name: 'TinyS-Black', tooltip: '10px / 900 / 135%' },
    { name: 'TinyS-Bold', tooltip: '10px / 700 / 135%' },
    { name: 'TinyS-Medium', tooltip: '10px / 500 / 135%' },
    { name: 'TinyS-Regular', tooltip: '10px / 400 / 135%' },
    { name: 'TinyS-Italic', tooltip: '10px / 300 / 135%' }
  ]
}
